import SvgIcon from '@mui/material/SvgIcon';

export default function OfficeEditIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg
                viewBox="0 0 24 24"
                version="1.1"
                id="svg1"
                width="576"
                height="576"
                xmlns="http://www.w3.org/2000/svg">
                <defs id="defs1" />
                <path fill='currentColor' id="path1-8" strokeWidth="0.743056"
                    d="M 5.9648438,7.6445312 V 10.615234 H 2.9921875 V 21.019531 H 8.9375 V 19.236328 L 7.6347656,20.539062 H 3.46875 V 16.373047 L 4.4785156,15.363281 V 15.074219 H 4.7675781 L 7.4511719,12.390625 V 12.101562 H 7.7402344 L 10.423828,9.4179688 V 9.1289062 h 0.289063 l 1.484375,-1.484375 z m 1.4863281,1.484375 H 8.9375 V 10.615234 H 7.4511719 Z M 4.4785156,12.101562 h 1.4863282 v 1.486329 H 4.4785156 Z m 10.1093754,1.486329 -2.677735,2.675781 v 0.296875 h -0.296875 l -1.486328,1.486328 h 0.296875 v 2.972656 h 5.94336 v -7.43164 z m -1.19336,1.486328 h 1.486328 v 1.486328 h -1.486328 z m 0,2.972656 h 1.486328 v 1.486328 h -1.486328 z" />
                <path fill='currentColor' id="path1-5" strokeWidth="0.888765"
                    d="m 4.031249,16.603186 v 3.33287 H 7.3641194 L 17.193865,10.10631 13.860995,6.77344 Z M 19.771285,7.528891 c 0.346619,-0.346619 0.346619,-0.906541 0,-1.25316 L 17.691574,4.19602 a 0.88521039,0.88521039 0 0 0 -1.253159,0 l -1.626441,1.626441 3.33287,3.33287 z" />
            </svg>
        </SvgIcon>
    );
}